<template>
    <article class="a-as-tabs-table">
        <div class="a-as-tabs-table__container">
            <article-header :header-data="headerData" />
            <div class="a-as-tabs-table__nav">
                <button
                    v-for="(navItem, i) in jsonMortgage.slice(0, 2)"
                    :key="i"
                    :data-id="i"
                    class="a-as-tabs-table__nav-btn"
                    :class="tabValue == i ? 'active' : ''"
                    type="botton"
                    @click.prevent="tabsContol"
                >
                    {{ navItem.title }}
                </button>
            </div>

            <div v-for="(table, i) in jsonMortgage.slice(0, 2)" :key="i" class="a-as-tabs-table__item">
                <table v-if="tabValue == i" class="a-table">
                    <thead>
                        <tr class="title-row">
                            <th v-for="(colTitle, j) in table.items[0]" :key="j" v-html="colTitle"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, j) in table.items.slice(1, table.items.length)" :key="j">
                            <td>{{ row[0] }}</td>
                            <td>
                                {{ row[1] }}
                                <span :class="checkDinamic(row[2])">{{ row[2] }}</span>
                            </td>
                            <td>
                                {{ row[3] }}
                                <span :class="checkDinamic(row[4])">{{ row[4] }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <article-footer :footer-data="footerData" />
    </article>
</template>

<script>
import ArticleHeader from '../../helpers/ArticleHeader';
import ArticleFooter from '../../helpers/ArticleFooter';

export default {
    name: 'AllStudyTabsTable',
    components: {
        ArticleHeader,
        ArticleFooter
    },
    props: {
        tabsTableData: Object
    },
    data() {
        return {
            headerData: {
                title: 'Выдача ипотеки',
                date: ''
            },
            footerData: {
                source: '',
                subString: '',
                button: {
                    src: '/analytics/mortgage/',
                    title: 'Ипотека',
                    color: 'white-arrow'
                }
            },
            tabValue: 0,
            monthes: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'],

            jsonMortgage: null
        };
    },
    methods: {
        tabsContol() {
            this.tabValue = event.target.getAttribute('data-id');

            const tabItems = this.jsonMortgage?.[2]?.items?.[this.tabValue];
            const title = this.jsonMortgage?.[2]?.title;

            if (tabItems && typeof tabItems === 'object' && Array.isArray(tabItems) && tabItems.length > 1 && title) {
                this.footerData.source = `${title} ${tabItems[0]}`;
                this.footerData.subString = tabItems[1];
            }
        },

        checkDinamic(str) {
            if (str.indexOf('+') === 0) return 'green';
            if (str.indexOf('-') === 0) return 'red';
        }
    },

    created() {
        let componentParent = document.querySelector('.js--a-indicator-table');
        if (!componentParent) {
            componentParent = document.querySelector('#app');
        }
        this.jsonMortgage = JSON.parse(componentParent.getAttribute('mortgage'));

        const title = this.jsonMortgage?.[2]?.title || '';
        const firstItem = this.jsonMortgage?.[2]?.items?.[0]?.[0] || '';
        const subStringValue = this.jsonMortgage?.[2]?.items?.[this.tabValue]?.[1];

        if (title) {
            this.footerData.source = `${title} ${firstItem}`.trim();

            if (subStringValue !== undefined) {
                this.footerData.subString = subStringValue;
            }
        }
    }
};
</script>
